import React, { Component } from "react";

export default class ButtonsContainer extends Component {
  render() {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 35 }}>
        {this.props.children}
      </div>
    );
  }
}
